export default __webpack_public_path__ + "static/media/logo-black.204416e7.svg";